<template>
    <div class="overflow-auto  pt-8px pb-8px">
        <div class="header flex items-center gap-8px  cursor-pointer" @click="handleBack" v-if="props.category">
            <el-icon class=" back-icon cursor-pointer">
                <ArrowLeft />
            </el-icon>
            <div class="title">{{ props.category.name }}</div>
        </div>
        <div class="pageList" ref="scrollRef" @scroll="onScroll">
            <div v-if="loading" class="List">
                <div v-for="n in 9" :key="n" class="image-item">
                    <el-skeleton animated>
                        <template #template>
                            <el-skeleton-item variant="image" class="skeleton-img" />
                        </template>
                    </el-skeleton>
                </div>
            </div>
            <div v-else class="List">
                <div v-for="item in listItems" :key="item.id" class="image-item">
                    <elementItem :template="item" />
                </div>
            </div>
            <div v-if="loadingMore" class="py-8px text-center text-12px text-[#999]">加载中...</div>
            <div v-else-if="!hasMore" class="py-8px text-center text-12px text-[#999]">已无更多</div>
        </div>
        <div v-if="listItems.length === 0 && !loading">
            <el-empty description="暂无数据" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getMaterialsItems } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty, ElSkeleton, ElSkeletonItem } from 'element-plus'
// @ts-ignore
import elementItem from './elmentItem.vue'
const props = defineProps<{
    category: any,

}>()
const searchValue = ref('')
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 50,
    type: 1,
})
const listItems = ref([]);
const loading = ref(true);
const pagetotle = ref(0);
const scrollRef = ref<HTMLElement | null>(null)
const loadingMore = ref(false)
const hasMore = ref(true)
const currentPage = ref(1)
const pageSize = ref(50)
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}

onMounted(() => {
    getList(1, false)
})
const allpage = ref(1)

const getList = (pageNo = 1, append = false) => {
    if (!append) loading.value = true
    loadingMore.value = append
    getMaterialsItems({ pageNum: pageNo, pageSize: pageSize.value, type: 2, category_id: props.category.id, name: searchValue.value }).then(res => {
        const items = res?.data?.data?.items || []
        if (append) {
            listItems.value = listItems.value.concat(items)
        } else {
            listItems.value = items
        }
        allpage.value = res?.data?.data?.total_pages || allpage.value
        hasMore.value = pageNo < allpage.value
    }).finally(() => {
        loading.value = false
        loadingMore.value = false
    })
}

const emit = defineEmits<{
    back: []
}>()
const handleBack = () => {
    emit('back')
}

const pagesearch = (val) => {
    searchValue.value = val
    resetPagination()
    currentPage.value = 1
    hasMore.value = true
    getList(1, false)
}
const onScroll = (e: Event) => {
    const el = (e.target as HTMLElement) || scrollRef.value
    if (!el || !hasMore.value || loadingMore.value) return
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16
    if (nearBottom) {
        currentPage.value += 1
        getList(currentPage.value, true)
    }
}
defineExpose({ pagesearch })
</script>
<style lang="scss" scoped>
.menu-items {
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    background-color: #fff;

    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    color: #666;
    padding: 4px 12px;
    height: 30px;

    &:hover {
        border-color: #2a66ff;
        color: #2a66ff;
    }

    &.active {
        background-color: #2a66ff;
        border-color: #2a66ff;
        color: #fff;
        height: 30px;
    }
}

.imageList {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
    margin-top: 16px;
}

.List {

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
    margin-top: 16px;
}

.pageList {
    // height: 500px;
    max-height: calc(100vh - 280px);
    overflow: auto;
    // background: red;
}

.image-item {
    width: 100%;
}

.skeleton-img {
    width: 100%;
    height: 80px;
    border-radius: 8px;
}
</style>
<style>
.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
    background-color: #2a66ff;
    border-color: #2a66ff;
    color: #fff;
}
</style>